export const MAX_UPLOAD_MB = 100

export type EvidenceFormData = {
  mime: string
  body: string | File
  caption?: string
}

export enum AddEvidenceErrorType {
  CAPTION = 'caption',
  DATE = 'date',
  EVIDENCE = 'evidence',
}

export enum EvidenceType {
  NULL = 'Null',
  TEXT = 'Text',
  LINK = 'Link',
  FILE = 'File',
  SHAREPOINTLINK = 'SharePointLink',
}

export const EvidenceErrorInitState = {
  captionError: '',
  dateError: '',
  evidenceError: '',
}

export const EvidenceFormDataInitState = {
  mime: '',
  body: '',
}

export type AddEvidenceErrors = {
  captionError: string
  dateError: string
  evidenceError: string
}
